import * as React from 'react';
import { makeIcon } from './makeIcon';
const Card = props => (React.createElement("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M2 2A1.5 1.5 0 00.5 3.5v9A1.5 1.5 0 002 14h12a1.5 1.5 0 001.5-1.5v-9A1.5 1.5 0 0014 2H2zm0 1.5h12V5H2V3.5zm0 3.75h12v5.25H2V7.25z" })));
export const CardIcon = makeIcon('card')(Card);
//# sourceMappingURL=Card.js.map